import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import SwitchField from "components/SwitchField";
import { memo } from "react";
import FormNumberField from "components/FormNumberField";

/* eslint-disable react/prop-types */
const countryOptions = [
  { value: "Việt Nam", label: "Việt Nam" },
  { value: "Lào", label: "Lào" },
  { value: "Trung Quốc", label: "Trung Quốc" },
];

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    address,
    countryName,
    airlinesName,
    quarter,
    year,
    firstTime,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    agencyName,
    agencyId,
    taxAgentContract,
    taxAgentContractDate,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
        <FormNumberField
            name={quarter.name}
            label={quarter.label}
            value={values.quarter}
            error={errors.quarter && touched.quarter}
            success={
              values.quarter?.toString().length > 0 && !errors.quarter
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
        <FormNumberField
            name={year.name}
            label={year.label}
            value={values.year}
            error={errors.year && touched.year}
            success={
              values.year?.toString().length > 0 && !errors.year
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={airlinesName.name}
            label={airlinesName.label}
            value={values.airlinesName}
            error={errors.airlinesName && touched.airlinesName}
            success={
              values.airlinesName?.toString().length > 0 && !errors.airlinesName
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={countryName.type}
            label={countryName.label}
            name={countryName.name}
            value={values.countryName}
            placeholder={countryName.placeholder}
            error={errors.countryName && touched.countryName}
            success={values.countryName.length > 0 && !errors.countryName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={
              values.address?.toString().length > 0 && !errors.address
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={agencyName.name}
            label={agencyName.label}
            value={values.agencyName}
            error={errors.agencyName && touched.agencyName}
            success={values.agencyName?.toString().length > 0 && !errors.agencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={agencyId.name}
            label={agencyId.label}
            value={values.agencyId}
            error={errors.agencyId && touched.agencyId}
            success={values.agencyId?.toString().length > 0 && !errors.agencyId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={
              values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={
              values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId
            }
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentContract.name}
            label={taxAgentContract.label}
            value={values.numberContract}
            error={errors.taxAgentContract && touched.taxAgentContract}
            success={values.taxAgentContract?.toString().length > 0 && !errors.taxAgentContract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
        <DatepickerField
            label={taxAgentContractDate.label}
            name={taxAgentContractDate.name}
            error={errors.taxAgentContractDate && touched.taxAgentContractDate}
            success={values.taxAgentContractDate?.toString().length > 0 && !errors.taxAgentContractDate}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

Fields.displayName = "Fields";

export default memo(Fields);